module.exports = __webpack_public_path__ + "static/media/umgefallener_baum.5afddb2b.svg";